// create the new userrole

import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  Select,
  MenuItem,
  SelectChangeEvent,
  useTheme,
} from '@mui/material'; // Import Select and MenuItem
import axios, { AxiosResponse } from 'axios';

import { UserRole } from './Userrole';
import { Link, useNavigate,useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ThemeProvider } from '@mui/material/styles';
import getTheme from '../../theme/theme';
import { UserRolefields } from '../../constants/userrolefields';
import { BASEURL, ARROW, AUTOFILL_STYLES } from '../../constants/Common';
import FloatingButton from '../usersupport/helpdesk/FloatingButton';

const AddUserRolePage: React.FC = () => {
  const [isSaving, setIsSaving] = useState(false);
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const storedData = localStorage.getItem('orgid');
  let parsedData: any = null; // Define parsedData variable with 'any' type

  if (storedData) {
    parsedData = JSON.parse(storedData);
  } else {
    navigate('/login')
  }
  const organizationid = parsedData;

  const { state } = location;
  // const { filteredRows } = state as { filteredRows: any[] }; // Type assertion to access filteredRows
  const filteredRows = state?.filteredRows || [];
 

  const [newLog, setNewLog] = useState<UserRole>({
    id: null,
    organization_id: organizationid,
    rolename: '',
    note: '',
    status: '', // Leave status empty initially to allow any string value
    projectaccess: '', // Leave projectaccess empty initially to allow any string value
    scheduleaccess: '', // Leave scheduleaccess empty initially to allow any string value
    modulesaccess: '', // Leave modulesaccess empty initially to allow any string value
    reportsaccess: '', // Leave reportsaccess empty initially to allow any string value
    createdon: 'new Date().toISOString()', // Convert Date to string with ISO format
    // createdon:'',
  });


  const formatDate = (dateString: string | Date | null): string => {
    if (!dateString) {
      return ''; // Return an empty string if dateString is null or undefined
    }

    const dateObject = new Date(dateString);
    const year = dateObject.getFullYear();
    const month = ('0' + (dateObject.getMonth() + 1)).slice(-2); // Adding 1 to month index since it's zero-based
    const day = ('0' + dateObject.getDate()).slice(-2);

    return `${year}-${month}-${day}`;
  };

  const handleInputChange = (
    event:
      | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
      | SelectChangeEvent<string>
  ) => {
    const { name, value } = event.target as
      | HTMLInputElement
      | HTMLTextAreaElement;
    setNewLog({ ...newLog, [name]: value });
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setIsSaving(true);
     
    if (!newLog.rolename) {
      toast.error('Rolename is required');
      setIsSaving(false);
      return;
    }
    if (!newLog.status) {
      toast.error('Status is required');
      setIsSaving(false);
      return;
    }
    if (!newLog.note) {
      toast.error('Note is required');
      setIsSaving(false);
      return;
    }
    if (!newLog.note) {
      toast.error('Note is required');
      setIsSaving(false);
      return;
    }
    if (!newLog.projectaccess) {
      toast.error('Projectaccess is required');
      setIsSaving(false);
      return;
    }
    if (!newLog.scheduleaccess) {
      toast.error('Scheduleaccess is required');
      setIsSaving(false);
      return;
    }
    if (!newLog.modulesaccess) {
      toast.error('Modulesaccess is required');
      setIsSaving(false);
      return;
    }

    // Check if the rolename already exists
    const existingRole = filteredRows.find((role: any) => role.rolename === newLog.rolename);
    if (existingRole) {
      toast.error('Rolename is already exists');
      setIsSaving(false);
      return;
    }

    try {
      // Convert newLog to JSON string
      const jsonData = JSON.stringify(newLog);
      // Send POST request to create a new user role
      const response = await axios.post(
        BASEURL + '/userrole/create/',
        jsonData, // Send JSON data
        {
          headers: {
            'Content-Type': 'application/json', // Set content type to JSON
          },
        }
      );

      toast.success('User role created successfully');
      // Redirect to the View Role page with the newly created user role ID as a query parameter
      navigate(`/view-role?role_id=${response.data.id}`); // Assuming the response contains the ID of the created user role
    } catch (error) {
      setIsSaving(false);
      console.error('Error creating user role:', error);
      toast.error('Failed to create user role');
    }
  };

  useEffect(() => {
    // Fetch the current date from the backend and update newLog's createdon
    const fetchCurrentDate = async () => {
      try {
        const response = await axios.get(BASEURL + '/get-current-date/');
        const currentDate = response.data.current_date;
        setNewLog((prevLog) => ({ ...prevLog, createdon: currentDate }));
      } catch (error) {
        console.error('Error fetching current date:', error);
      }
    };

    fetchCurrentDate(); // Call the function on component mount
  }, []); // Empty dependency array to run once on mount

  const handleCancelClick = () => {
    navigate('/userrole');
  };

  // Add this function outside your component

  return (
    <ThemeProvider theme={getTheme()}>
      <Box sx={{ mt: '-80px' }}>
        <Typography variant='h6' gutterBottom>
          <Link to={'/userrole'}>User Role</Link>
          {ARROW} Add Role
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {UserRolefields.map(
              (field) =>
                !['projectcode'].includes(field.name) && (
                  <Grid item xs={12} key={field.name} sx={{ mb: '10px' }}>
                    <Grid container spacing={2} alignItems='center'>
                      <Grid item xs={4}>
                        <Typography>{field.title}</Typography>
                      </Grid>
                      <Grid item xs={8}>
                        <Box sx={{ maxWidth: '350px' }}>
                          {field.type === 'dropDown' ? (
                            <Select
                              fullWidth
                              variant='outlined'
                              name={field.name}
                              value={
                                newLog[field.name] !== null
                                  ? (newLog[field.name] as string)
                                  : ''
                              }
                              onChange={handleInputChange}
                            >
                              {field.options?.map((option) => (
                                <MenuItem key={option} value={option}>
                                  {option}
                                </MenuItem>
                              ))}
                            </Select>
                          ) : field.name === 'note' ? (
                            <TextField
                              name={field.name}
                              value={newLog[field.name]}
                              onChange={handleInputChange}
                              fullWidth
                              margin='normal'
                              variant='outlined'
                              multiline
                              rows={3}
                            />
                          ) : field.name === 'attachments' ? (
                            <input type='file' />
                          ) : field.name === 'createdon' ? ( // Add this condition for createdon field
                            <TextField
                              name={field.name}
                              type='text' // Change type to text for custom formatting
                              value={formatDate(newLog.createdon)} // Format the date using formatDate function
                              onChange={handleInputChange}
                              fullWidth
                              margin='normal'
                              variant='outlined'
                              InputProps={{ readOnly: true }} // Set readOnly to make it non-editable
                            />
                          ) : (
                            <TextField
                              name={field.name}
                              type={
                                field.type === 'date'
                                  ? 'date'
                                  : field.type === 'dropzone'
                                    ? 'dropzone'
                                    : 'text'
                              }
                              value={newLog[field.name]}
                              onChange={handleInputChange}
                              fullWidth
                              margin='normal'
                              variant='outlined'
                              sx={{
                                ...AUTOFILL_STYLES(theme),
                              }}
                            />
                          )}
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                )
            )}
          </Grid>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: '20px' }}>
            <Button
              type='submit'
              variant='contained'
              color='primary'
              sx={{ marginRight: '10px' ,'&:disabled': { bgcolor: 'grey.400', color: 'grey.700' } }}
              disabled={isSaving}
            >
              Save
            </Button>
            <Button variant='contained' onClick={handleCancelClick}>
              Cancel
            </Button>
          </Box>
        </form>
        <FloatingButton/>
      </Box>
    </ThemeProvider>
  );
};

export default AddUserRolePage;
